var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 520 520",
      "width": "200",
      "height": "200"
    }
  }, [_c('g', {
    staticStyle: {
      "transform-origin": "469.875px 74.3767px"
    },
    attrs: {
      "id": "svg-1",
      "transform": "matrix(0.98717111, 0, 0, 0.98692697, -215.41589685, 178.50606502)"
    }
  }, [_c('g', {
    attrs: {
      "id": "SVGRepo_bgCarrier",
      "stroke-width": "0",
      "transform": "matrix(1, 0, 0, 1, 213.874664, -181.623291)"
    }
  }), _c('g', {
    attrs: {
      "id": "SVGRepo_tracerCarrier",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "transform": "matrix(1, 0, 0, 1, 213.874664, -181.623291)"
    }
  }), _c('g', {
    attrs: {
      "id": "SVGRepo_iconCarrier",
      "transform": "matrix(1, 0, 0, 1, 213.874664, -181.623291)"
    }
  }, [_c('circle', {
    staticStyle: {
      "fill": "rgb(33, 150, 243)"
    },
    attrs: {
      "cx": "256",
      "cy": "256",
      "r": "256"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "rgb(28, 129, 210)"
    },
    attrs: {
      "d": "M508.497,298.324L373.226,163.052l-103.291,104.01L145.67,402.101l109.894,109.894 c0.147,0,0.291,0.005,0.436,0.005C382.966,512,488.324,419.566,508.497,298.324z"
    }
  }), _c('polygon', {
    staticStyle: {
      "fill": "#f4e3c3"
    },
    attrs: {
      "points": "299.386,89.212 145.67,89.212 145.67,402.101 373.226,402.101 373.226,163.052 "
    }
  }), _c('polygon', {
    staticStyle: {
      "fill": "#fed8b2"
    },
    attrs: {
      "points": "373.226,163.052 299.386,89.212 254.85,89.212 254.85,402.101 373.226,402.101 "
    }
  }), _c('polygon', {
    staticStyle: {
      "fill": "#ffd15d"
    },
    attrs: {
      "points": "299.386,163.052 373.226,163.052 299.386,89.212 "
    }
  }), _c('g', [_c('rect', {
    staticStyle: {
      "fill": "#f9b54c"
    },
    attrs: {
      "x": "211.178",
      "y": "188.768",
      "width": "128.431",
      "height": "6.896"
    }
  }), _c('rect', {
    staticStyle: {
      "fill": "#f9b54c"
    },
    attrs: {
      "x": "168.943",
      "y": "188.768",
      "width": "28.444",
      "height": "6.896"
    }
  }), _c('rect', {
    staticStyle: {
      "fill": "#f9b54c"
    },
    attrs: {
      "x": "211.178",
      "y": "217.212",
      "width": "128.431",
      "height": "6.896"
    }
  }), _c('rect', {
    staticStyle: {
      "fill": "#f9b54c"
    },
    attrs: {
      "x": "168.943",
      "y": "217.212",
      "width": "28.444",
      "height": "6.896"
    }
  }), _c('rect', {
    staticStyle: {
      "fill": "#f9b54c"
    },
    attrs: {
      "x": "211.178",
      "y": "245.657",
      "width": "128.431",
      "height": "6.896"
    }
  }), _c('rect', {
    staticStyle: {
      "fill": "#f9b54c"
    },
    attrs: {
      "x": "168.943",
      "y": "245.657",
      "width": "28.444",
      "height": "6.896"
    }
  }), _c('rect', {
    staticStyle: {
      "fill": "#f9b54c"
    },
    attrs: {
      "x": "211.178",
      "y": "274.101",
      "width": "128.431",
      "height": "6.896"
    }
  }), _c('rect', {
    staticStyle: {
      "fill": "#f9b54c"
    },
    attrs: {
      "x": "168.943",
      "y": "274.101",
      "width": "28.444",
      "height": "6.896"
    }
  }), _c('rect', {
    staticStyle: {
      "fill": "#f9b54c"
    },
    attrs: {
      "x": "237.899",
      "y": "343.488",
      "width": "56.889",
      "height": "6.896"
    }
  })]), _c('g', [_c('rect', {
    staticStyle: {
      "fill": "#f4a200"
    },
    attrs: {
      "x": "254.845",
      "y": "188.768",
      "width": "84.764",
      "height": "6.896"
    }
  }), _c('rect', {
    staticStyle: {
      "fill": "#f4a200"
    },
    attrs: {
      "x": "254.845",
      "y": "217.212",
      "width": "84.764",
      "height": "6.896"
    }
  }), _c('rect', {
    staticStyle: {
      "fill": "#f4a200"
    },
    attrs: {
      "x": "254.845",
      "y": "245.657",
      "width": "84.764",
      "height": "6.896"
    }
  }), _c('rect', {
    staticStyle: {
      "fill": "#f4a200"
    },
    attrs: {
      "x": "254.845",
      "y": "274.101",
      "width": "84.764",
      "height": "6.896"
    }
  }), _c('rect', {
    staticStyle: {
      "fill": "#f4a200"
    },
    attrs: {
      "x": "254.845",
      "y": "343.488",
      "width": "39.943",
      "height": "6.896"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#f4a200"
    },
    attrs: {
      "d": "M340.34,334.932c1.5,0,2.717-1.217,2.717-2.717v-1.857c0-5.627-5.32-10.214-11.936-10.393v-0.71 c0-1.5-1.217-2.717-2.717-2.717c-1.5,0-2.717,1.217-2.717,2.717v0.71c-6.616,0.179-11.936,4.765-11.936,10.393v3.713 c0,5.627,5.32,10.214,11.936,10.392v13.665c-3.562-0.155-6.501-2.36-6.501-4.96v-1.857c0-1.5-1.217-2.717-2.717-2.717 c-1.5,0-2.717,1.217-2.717,2.717v1.857c0,5.627,5.32,10.214,11.936,10.392v0.71c0,1.5,1.217,2.717,2.717,2.717 c1.5,0,2.717-1.217,2.717-2.717v-0.71c6.616-0.179,11.936-4.765,11.936-10.392v-3.713c0-5.627-5.32-10.214-11.936-10.393v-13.665 c3.562,0.155,6.501,2.36,6.501,4.96v1.857C337.624,333.715,338.839,334.932,340.34,334.932z M319.185,334.072v-3.713 c0-2.6,2.939-4.806,6.501-4.96v13.634C322.124,338.877,319.185,336.672,319.185,334.072z M337.624,349.456v3.713 c0,2.6-2.939,4.805-6.501,4.96v-13.634C334.684,344.65,337.624,346.857,337.624,349.456z"
    }
  })])])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }